export const AdviceArea = {
    391: 'Insurance & Protection',
    396: 'Auto Enrolment',
    397: 'Investments & Savings',
    392: 'Mortgages',
    393: 'Pension & Retirement',
    557: 'Pension & Retirement',
    394: 'Equity Release',
    558: 'Inheritance Planning',
    395: 'Annuities',
};

export const AdviceAreaStats = {
    391: 968,
    396: 448,
    397: 1012,
    393: 929,
    557: 480,
    394: 312,
    558: 780,
    395: 810,
};



// WEBPACK FOOTER //
// ./src/constants/AdviceArea.js